import { Card } from '@newcore/ui/card';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Skeleton } from '@newcore/ui/skeleton';
import { Text } from '@newcore/ui/typography';
import { STEP_LABELS } from '../constants/mcp-tester-content';

const STEP_COUNT = Object.keys(STEP_LABELS).length;

export function DiagnosisPending() {
  return (
    <Card className='p-4' data-testid='mcp-tester-running'>
      <Text as='p' size={TextSizes.SM} className='text-tertiary'>
        Probing the server. This reaches out to it and to whatever authorization
        server it names, so it can take a few seconds.
      </Text>
      <div className='flex flex-col gap-3 pt-4'>
        {Array.from({ length: STEP_COUNT }, (_, index) => (
          <div key={index} className='flex items-center gap-3'>
            <Skeleton className='size-5 shrink-0 rounded-full' />
            <Skeleton className='h-4 w-full max-w-sm' />
          </div>
        ))}
      </div>
    </Card>
  );
}
